/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { StaticDomainConfiguration } from 'src/components/ZillowNavbar/page-frame-types/StaticDomainConfiguration';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { DesktopZillowLogoSVGImage } from './components/DesktopZillowLogoSVGImage';
import { SizedMobileSizeZillowLogo } from './components/SizedMobileSizeZillowLogo';

export type ZillowLogoHeaderVersions = Exclude<
    HEADER_VERSIONS,
    HEADER_VERSIONS.ZHL_DEFAULT | HEADER_VERSIONS.SEARCH_MOBILE_ONLY
>;

export type ZillowNavbarZillowLogoProps = {
    /** Used for configuring static asset resolution */
    staticDomain: StaticDomainConfiguration;
    /** Used for determining whether to show the default or transparent logo */
    version: ZillowLogoHeaderVersions;
    /** Used for determining whether to show the default or transparent logo */
    isMobileNavOpen: boolean;
};

/**
 * Renders the full Zillow Logo, supporting transparent mobile navbars
 */
export const ZillowLogo: FunctionComponent<ZillowNavbarZillowLogoProps> = ({
    version,
    isMobileNavOpen,
    staticDomain,
}) => (
    <>
        <DesktopZillowLogoSVGImage
            isMobileNavOpen={isMobileNavOpen}
            version={version}
            svgFileName="z-logo-default"
            svgName="Zillow logo"
            staticDomain={staticDomain}
        />
        {version === HEADER_VERSIONS.TRANSPARENT_MOBILE_ONLY && (
            <SizedMobileSizeZillowLogo
                isMobileNavOpen={isMobileNavOpen}
                version={version}
                staticDomain={staticDomain}
            />
        )}
    </>
);
